import { Component, ElementRef, Input, ViewChild } from '@angular/core';

import { Store } from '@ngrx/store';

import { ImageParentType } from '@image-upload/enums/image-parent-type.enum';
import {
  ImageUploadActions,
  ImageUploadSelectors,
} from '@image-upload/reducers/image-upload.slice';

// TODO error handling
@Component({
  selector: 'app-image-picker',
  styleUrls: ['./image-picker.component.scss'],
  templateUrl: './image-picker.component.html',
})
export class ImagePickerComponent {
  @Input() imageParentType: ImageParentType | null | undefined;
  @Input() parentId: string | null | undefined;
  @Input() disabled: boolean = false;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;

  isUploading$ = this.store.select(ImageUploadSelectors.selectIsUploading);
  uploadProgress$ = this.store.select(
    ImageUploadSelectors.selectUploadProgress
  );

  constructor(private readonly store: Store) {}

  onUploadImage(event: Event): void {
    const files: FileList | null = (event.target as HTMLInputElement).files;

    if (files && this.imageParentType) {
      this.store.dispatch(
        ImageUploadActions.upload.trigger({
          file: files[0],
          request: {
            refType: this.imageParentType,
            refId: this.parentId ?? '',
            alt: files[0].name,
            isDefault: false,
          },
        })
      );

      if (this.fileInput) {
        (this.fileInput.nativeElement as HTMLInputElement).value = '';
      }
    }
  }
}
